
GP.vent.on("user:activate_email_modal", function(self) {
    
    var apis = {
        resend_validation_email: function() {
            $.ajax({
                url: '/members/user/validate_email/?ajax=1&send_conf=1',
                dataType: 'html',
                success: function(data) {
                    $('#resend_email_txt').show();
                    setTimeout(function() {
                        vent.trigger('Modal:close');
                    }, 2000);
                }
            });
        },
        change_activate_email_address: function(_new_email) {
            $.post('/members/user/edit_account', {
                email: _new_email,
                section: 'login_settings',
                actvtmod: 1,
                process: 1,
            }).done(function(json) {
                if (json.errors) {
                    events.show_change_email_errors(json.errors);
                }

                if (json.status) {
                    events.show_change_email_success(json.msg);
                }
            });
        }
    };

    var events = {
        show_change_email_errors: function(_errors) {
            $('.js-change-email-error').empty();
            $.each(_errors, function(i,val) {
                $('.js-change-email-error').append('<p class="error">'+val+'</p>')
                .removeClass('hide');
            });
        },
        show_change_email_success: function(_success_msg) {
            $('.js-change-email-error').addClass('hide');
            $('.js-change-email-success').empty().append('<p>'+_success_msg+'</p>')
            .removeClass('hide');
        }
    };

    $(document).on('click', '.js-resend-email', function(e) {
        e.preventDefault();
        apis.resend_validation_email();
    });

    $(document).on('click', '.js-change-activate-email', function(e) {
        e.preventDefault();
        $('.change-email-wrap').removeClass('hide');
    });

    $(document).on('click', '.js-cancel-change-email', function(e) {
        e.preventDefault();
        $('.change-email-wrap').addClass('hide');
    });

    $(document).on('click', '.btn-change-activate-email', function(e) {
        e.preventDefault();
        var _new_email_address = $('.input-change-activate-email').val();

        if (_new_email_address.length) {
            apis.change_activate_email_address(_new_email_address);
        }
    });

    $(document).on('click', '.js-change-activate-toggle', function(e) {
        e.preventDefault();
        $('.activate-options-list').toggleClass('hide');
    });
});